import React, { useState } from 'react';
import styled from 'styled-components';
import { useAuth } from '../contexts/AuthContext';
import { colors } from '../styles';
import { UserOutlined, LockOutlined, GoogleOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { useToast } from '../contexts/ToastContext';

const Input = ({ icon, ...props }) => (
  <StyledInput>
    {icon}
    <input {...props} />
  </StyledInput>
);

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const { login, loginWithGoogle } = useAuth();
  const navigate = useNavigate();
  const toast = useToast();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.showToast('Inicio de sesión exitoso', 'success');
      navigate('/');
    } catch (err) {
      console.error(err);
      toast.showToast('Error al iniciar sesión', 'error');
    } finally {
      setLoading(false);
    }
  };

  return (
    <LoginContainer>
      <LoginCard>
        <Title>Iniciar Sesión</Title>
        <Form onSubmit={handleSubmit}>
          <FormGroup>
            <Input
              type="email"
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              icon={<UserOutlined />}
            />
          </FormGroup>
          <FormGroup>
            <Input
              type="password"
              placeholder="Contraseña"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              icon={<LockOutlined />}
            />
          </FormGroup>
          <StyledButton type="submit" disabled={loading}>
            {loading ? 'Iniciando...' : 'Iniciar Sesión'}
          </StyledButton>
        </Form>
        <Divider>o</Divider>
        <GoogleButton type="button" onClick={loginWithGoogle}>
          <GoogleOutlined /> Continuar con Google
        </GoogleButton>
        <RegisterLink type="button" onClick={() => navigate('/register')}>
          ¿No tienes cuenta? Regístrate
        </RegisterLink>
      </LoginCard>
    </LoginContainer>
  );
};

const LoginContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  padding: 2rem;
  background-color: ${colors.primary};
`;

const LoginCard = styled.div`
  background: ${colors.white};
  padding: 2rem;
  border-radius: 8px;
  box-shadow: 0 4px 12px ${colors.shadow};
  width: 100%;
  max-width: 400px;
`;

const Title = styled.h2`
  font-family: 'Caveat', cursive;
  color: ${colors.text};
  font-size: 2.5rem;
  text-align: center;
  margin-bottom: 2rem;
`;

const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

const FormGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

const StyledInput = styled.div`
  position: relative;
  
  input {
    width: 100%;
    padding: 0.8rem;
    padding-left: 2.5rem;
    border: 1px solid ${colors.border};
    border-radius: 8px;
    font-family: 'Indie Flower', cursive;
    font-size: 1rem;
    
    &:focus {
      outline: none;
      border-color: ${colors.secondary};
    }
  }
  
  .anticon {
    position: absolute;
    left: 0.8rem;
    top: 50%;
    transform: translateY(-50%);
    color: ${colors.text}80;
  }
`;

const StyledButton = styled.button`
  height: auto;
  padding: 0.8rem;
  font-size: 1.1rem;
  font-family: 'Indie Flower', cursive;
  background-color: ${colors.secondary};
  border: none;
  color: ${colors.white};
  border-radius: 8px;
  cursor: pointer;

  &:hover {
    background-color: ${colors.accent};
  }

  &:disabled {
    background-color: ${colors.text}80;
    cursor: not-allowed;
  }
`;

const Divider = styled.div`
  text-align: center;
  margin: 1rem 0;
  color: ${colors.text};
  font-family: 'Indie Flower', cursive;
`;

const GoogleButton = styled.button`
  background-color: transparent;
  border: 2px solid ${colors.secondary}40;
  color: ${colors.text};
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  padding: 0.8rem;
  border-radius: 8px;
  cursor: pointer;

  &:hover {
    background-color: ${colors.secondary}10;
    border-color: ${colors.secondary};
  }
`;

const RegisterLink = styled.button`
  background: none;
  border: none;
  color: ${colors.secondary};
  font-family: 'Indie Flower', cursive;
  font-size: 1rem;
  cursor: pointer;
  margin-top: 1rem;
  padding: 0.5rem;
  width: 100%;
  transition: all 0.3s ease;

  &:hover {
    color: ${colors.accent};
    text-decoration: underline;
  }
`;

export default Login; 